import { render } from "./InvSettingList.vue?vue&type=template&id=0038015c"
import script from "./InvSettingList.vue?vue&type=script&lang=js"
export * from "./InvSettingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__